import { render } from "./Home.vue?vue&type=template&id=0410c760"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0410c760&lang=css"

import exportComponent from "C:\\Users\\naska\\Desktop\\Javascript Portfolio Projects\\movie-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__